import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=4770d5df&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=js"
export * from "./FormPanel.vue?vue&type=script&lang=js"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=4770d5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770d5df",
  null
  
)

export default component.exports